import { Response } from '@angular/http';
import { Injectable } from '@angular/core';

// Rxjs
import { _throw } from 'rxjs/observable/throw';
import { Observable } from 'rxjs/Observable';

// Services
import { HttpService } from '../../core/services/http.service';

// Base URL
import { BASE_URL } from '../../core/services/api';

@Injectable()
export class ProjectService {

  // Base URL
  private PATH: string = BASE_URL + 'project/';
  private PATH_CATALOGUE: string = BASE_URL + 'catalogue';

  // Constructor
  constructor(private http: HttpService) { }

  // Get Project
  public getProjectByID(project_id): Observable<Response> {
    return this.http.get(this.PATH + 'project/get-project?project_id=' + project_id);
  }

  // Get Current User Roles and Permissions
  public getCurrentUserRolesAndPermissions(data: { project_id: number }): Observable<Response> {
    return this.http.get(BASE_URL + 'user/role/role-permissions-current-user?project_id=' + data.project_id);
  }

  // Get Project Settings
  public getProjectSettings(data: { project_id: number }): Observable<Response> {
    return this.http.get(this.PATH + 'project/project-settings?project_id=' + data.project_id);
  }

  // Get User Project Permissions
  public getUserProjectPermissions(data: { project_id: number }): Observable<Response> {
    return this.http.get(BASE_URL + 'user/role/get-permissions?project_id=' + data.project_id);
  }

  // Get Wizard Data
  public getWizardData(data): Observable<Response> {
    return this.http.get(BASE_URL + 'project/project/wizard?project_id=' + data.project_id);
  }
  // Get Project Focus Prompt
  public getProjectFocusPrompt(lan_code: string, project_id: number): Observable<Response> {
    return this.http.post(this.PATH + 'project/get-project-focus-prompt', { lan_code, project_id });
  }
  // Save Project Focus Prompt
  public saveProjectFocusPrompt(project_id: number, project_prompt: string, font: number, project_lan: string): Observable<Response> {
    return this.http.post(this.PATH + 'project/add-project-focus-prompt', { project_id, project_prompt, font, project_lan });
  }

  // Get Project Informed Consent
  public getProjectInformedConsent(lan_code: string, project_id: number): Observable<Response> {
    return this.http.post(this.PATH + 'project/get-project-informed-consent', { lan_code, project_id });
  }

  // Set Project Default Welcome Title
  public setDefaultInformedConsent (lan_code: string, project_id: number): Observable<Response> {
    return this.http.post(this.PATH + 'project/default-informed-consent', { lan_code, project_id });
  }

  // Save Project Informed Consent
  public saveProjectInformedConsent(informed_consent): Observable<Response> {
    return this.http.post(this.PATH + 'project/add-project-informed-consent', informed_consent);
  }

  // Get Project Welcome Message
  public getProjectWelcomeMessage(lan_code: string, project_id: number): Observable<Response> {
    return this.http.post(this.PATH + 'project/get-project-welcome-message', { lan_code, project_id });
  }

  // Save Project Welcome Message
  public saveProjectWelcomeMessage(project_id: number, welcome_title: string, welcome_message: string, welcome_lan: string): Observable<Response> {
    return this.http.post(this.PATH + 'project/add-project-welcome-message', { project_id, welcome_title, welcome_message, welcome_lan });
  }

  // Set Project Default Welcome Title
  public setProjectDefaultWelcomeTitle(lan_code: string, project_id: number): Observable<Response> {
    return this.http.post(this.PATH + 'project/default-welcome-title', { lan_code, project_id });
  }

  // Set Project Default Welcome Text
  public setProjectDefaultWelcomeText(lan_code: string, project_id: number): Observable<Response> {
    return this.http.post(this.PATH + 'project/default-welcome-text', { lan_code, project_id });
  }

  // Get Project Thank You Message
  public getProjectThankYouMessage(lan_code: string, project_id: number): Observable<Response> {
    return this.http.post(this.PATH + 'project/get-project-completion-message', { lan_code, project_id });
  }

  // Save Project Thank You Message
  public saveProjectThankYouMessage(project_id: number, project_title: string, project_message: string, project_lan: string,
      project_status: boolean, project_url: string): Observable<Response> {
    return this.http.post(this.PATH + 'project/add-project-completion-message',
    { project_id, project_title, project_message, project_lan, project_status, project_url});
  }

  // Set Project Default Welcome Title
  public setProjectDefaultThankYouTitle(lan_code: string, project_id: number): Observable<Response> {
    return this.http.post(this.PATH + 'project/default-completion-title', { lan_code, project_id });
  }

  // Set Project Default Welcome Text
  public setProjectDefaultThankYouText(lan_code: string, project_id: number): Observable<Response> {
    return this.http.post(this.PATH + 'project/default-completion-text', { lan_code, project_id });
  }

  // Invite User To Project With Role
  public inviteUserToProject(user): Observable<Response> {
    return this.http.post(this.PATH + 'project-administrator/invite-user-to-project-with-role', user);
  }

  // Get the Users Assigned to a Project
  public getUserListProject(project_id: string): Observable<Response> {
    return this.http.post(this.PATH + 'project-administrator/get-user-list-by-project', { project_id });
  }

  // Get the Roles and Permissions
  public getRolesAndPermissions(ownerIncluded: boolean, deep: boolean): Observable<Response> {
    return this.http.post(BASE_URL + 'user/role/get-roles-and-permissions', { ownerIncluded, deep });
  }

  // Get User Roles and Permissions
  public getUserRolesAndPermissions(userId: number, project_id: number): Observable<Response> {
    return this.http.post(BASE_URL + 'user/role/get-role-and-permissions-by-user', { userId, project_id });
  }

  public assignUserPermissions(userId: number, project_id: number, role: string, permissions: Array<string>) {
    return this.http.post(BASE_URL + 'user/role/assign-permission', { userId, project_id, role, permissions });
  }

  public deleteUserFromProject(email: string, project_id: string) {
    return this.http.post(this.PATH + 'project-administrator/delete-user-from-project', { email, project_id });
  }

  public deactivateUserFromProject(email: string, project_id: string) {
    return this.http.post(this.PATH + 'project-administrator/disable-user-from-project', { email, project_id });
  }

  // Edit Project Information
  public editProjectInformation(project_id: number, name: string, abbreviation: string, color: string, logo: any,
                                default_language: number, hide_english: number, notification_90: number,
                                notification_95: number, notification_99: number): Observable<Response> {
    return this.http.post(this.PATH + 'project/edit', { project_id, name, abbreviation, color, logo,
      default_language, hide_english, notification_90, notification_95, notification_99 });
  }

  // Edit Project Information
  public editProjectContactData(project_id: number, contactEmail: string, countryCode: string, dialCode: string, phoneNumber: string): Observable<Response> {
    return this.http.post(this.PATH + 'project/edit-contact-data', { project_id, contactEmail, countryCode, dialCode, phoneNumber });
  }

  // Update Project Logo
  public updateLogoProject(data): Observable<Response> {
    return this.http.post(this.PATH + 'project/edit', data);
  }

  // Edit Project Information
  public changeProjectStatus(project_id: number, status_id: number): Observable<Response> {
    return this.http.post(this.PATH + 'project/change-project-status', { project_id, status_id});
  }

  // Request send the file by email
  public requestSend(data): Observable<Response> {
    return this.http.post(this.PATH + 'export/require-send', data);
  }

  // Get Randomize Types
  public getRandomizeType(): Observable<Response> {
    return this.http.get(this.PATH_CATALOGUE + '/index/randomize-type');
  }

  // Get Registration Types
  public getRegistrationType(): Observable<Response> {
    return this.http.get(this.PATH_CATALOGUE + '/index/registration-type');
  }

  // Get Open Close Types
  public getOpenCloseType(): Observable<Response> {
    return this.http.get(this.PATH_CATALOGUE + '/index/open-close-type');
  }

  // Get Layout Types
  public getLayoutType(): Observable<Response> {
    return this.http.get(this.PATH_CATALOGUE + '/index/layout-type');
  }

  // Get Activity Status Types
  public getGetActivityStatusTypes(): Observable<Response> {
    return this.http.get(this.PATH_CATALOGUE + '/index/activity-status');
  }

  // Get Project Setting
  public getProjectSetting(project_id: number): Observable<Response> {
    return this.http.get(this.PATH + 'project/project-settings?project_id=' + project_id);
  }

  public exportProject(data): Observable<Response> {
    return this.http.get(this.PATH + 'export/export?project_id=' + data.project_id);
  }
}



// WEBPACK FOOTER //
// ./src/app/project/services/project.service.ts